import { defineMessages } from 'react-intl';

export default defineMessages({
    repairFacilityMapHeader: {
        id: 'fnol.ca.views.ca-preferred-body-shop.What recommended repair facility suits you best?',
        defaultMessage: 'What recommended repair facility suits you best?',
    }
});
